import { useLazyQuery } from '@apollo/client'

import { NETWORK_ONLY_FETCH_POLICY } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   convertToErrorType,
   getAPIStatusFromNetworkStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'

import {
   OpenSearchPipelineItemsQueryVariables as QueryVariables,
   OpenSearchPipelineItemsQuery as Query,
   OpenSearchPipelineItemsDocument as QueryDocument
} from './query.generatedTypes'
import useAPIResponseHandler from './responseHandler'

interface TriggerAPIArgsType {
   requestObj: QueryVariables['params']
   onSuccess?: () => void
   onFailure?: (error: Error) => void
}

const useGetOpenSearchPipelineItems = () => {
   const [
      getOpenSearchPipelineItems,
      { data, error, networkStatus, fetchMore }
   ] = useLazyQuery<Query, QueryVariables>(QueryDocument, {
      fetchPolicy: NETWORK_ONLY_FETCH_POLICY
   })

   const { searchResults, totalCount } = useAPIResponseHandler(data)

   const triggerAPI = async (args: TriggerAPIArgsType) => {
      await getOpenSearchPipelineItems({
         variables: { params: args.requestObj },
         onCompleted: args.onSuccess,
         onError: args.onFailure
      })
   }

   const fetchMoreSearchResults = async (args: TriggerAPIArgsType) => {
      await fetchMore({
         variables: { params: args.requestObj }
      })
   }
   return {
      apiError: convertToErrorType(error),
      apiStatus: getAPIStatusFromNetworkStatus(networkStatus, data),
      searchResults,
      fetchMore: fetchMoreSearchResults,
      totalCount,
      triggerAPI
   }
}

export default useGetOpenSearchPipelineItems
